const productTypes = {
  FILL_PRODUCTS: "FILL_PRODUCTS",
  SORT_PRODUCTS: "SORT_PRODUCTS"
};
export default productTypes;